// Generated by purs version 0.15.15
var retryDelayMs = function (attempt) {
    var $1 = attempt <= 1;
    if ($1) {
        return 500.0;
    };
    return 1000.0;
};
export {
    retryDelayMs
};
//# sourceMappingURL=index.js.map
